/* eslint-disable */
import { resetDrawTable } from './table-header-plugin'
import { cloneDeep } from 'lodash'
// import { setScrollLeft as qtSetScrollLeft } from '@/shared/home-modules/helpers/check-rules/utils/common.js'

// 根据key，设置滚动条位置，保持key在可显示区域
export const qtSetScrollLeft = (vm, key) => {
  // left 滚动条到最右边表格距离
  const { canvas, box, canvasConfig, allColData, fixedLeftCol, scroll, hScrollbar, vScrollbar, horizontal, ratio } = vm
  // 盒子宽度
  const boxWidth = box.offsetWidth * ratio

  const index = allColData.findIndex(item => item.key === key)
  if(index === -1) return
  const col = allColData[index]
  const width = parseInt(col.width)
  const _colData = allColData.slice(0, index)
  // 不包含key所在列
  const _colWidth = _colData.reduce((c, v) => c += v.width, 0)
  const fixedColWidth = fixedLeftCol.reduce((c, v) => c += v.width, 0)

  let disW = horizontal.offsetWidth - hScrollbar.offsetWidth
  const overWidth = canvasConfig.aw - canvas.offsetWidth
  let disx = scroll.disx

  // 字段未在可限时区域，需移动滚动条
  const _r = (col.x - disx + width) > boxWidth
  const _l = _colWidth < (disx + fixedColWidth)
  if (_l || _r) {
    // 左边距
    if (_l) {
      disx = _colWidth - fixedColWidth
    }
    // 右边距
    if (_r) {
      disx = _colWidth - boxWidth + col.width
    }
    // 横向滚动距离 如果小于 0
    if (disx <= 0) {
      disx = 0
    } else if (disx >= overWidth) {
      // 横向滚动距离 >= 数据溢出出宽度
      disx = overWidth
    }

    hScrollbar.style.left = (disx / overWidth) * disW + 'px'
    scroll.disx = disx
    vm.getDisplayCol()
    vm.handleShowText()
    vm.paint()
    vm.$emit('table-scroll', {
      type: 'hScroll',
      disx: vm.scroll.disx,
      disy: vm.scroll.disy,
      scrollLeft: hScrollbar.offsetLeft,
      scrollTop: vScrollbar.offsetTop
    })
  }
}

export const collapseType = {
  expand: 'expand',
  collapse: 'collapse'
}

const collapseMode = {
  hover: 'hover'
}

let updateTableTimer

function getFixedColx(col, fixedLeftCol = [], useFixedColumns = [], colWidthMap) {
  let fixedColX = 0
  const index = fixedLeftCol.findIndex(item => item.key === useFixedColumns[0].key)
  const _fixedLeftColumns = cloneDeep([...fixedLeftCol.slice(0, index), ...useFixedColumns])
  for (let i = 0; i < _fixedLeftColumns.length; i++) {
    const fcol = _fixedLeftColumns[i]
    const width = getColWidth(colWidthMap, fcol)
    if (col.key === fcol.key) {
      return fixedColX
    }
    if (fcol.show === true) {
      fixedColX += width
    }
  }
  return fixedColX
}

export function getCanvasDisx(tableListVm, columnHighlightGroup, type) {
  const tableVm = tableListVm.$refs.table || {}
  const scrollLeft = tableListVm._scrollLeft
  const highlightGroupWidth = columnHighlightGroup.reduce((res, cur) => res += cur.reduce((c, v) => c += v.width, 0), 0)
  const { canvasConfig, canvas, box, ratio, horizontal } = tableVm
  const aw = type === collapseType.expand ? canvasConfig.aw + highlightGroupWidth : canvasConfig.aw - highlightGroupWidth
  const overWidth = aw - canvas.offsetWidth
  const boxWidth = box.offsetWidth * ratio
  try {
    let _left = parseInt(scrollLeft) || 0
    const hScrollbarWidth = boxWidth * boxWidth / aw / ratio
    let disW = horizontal.offsetWidth - hScrollbarWidth
    if (aw >= boxWidth && _left > 0) {
      if (_left >= disW) {
        _left = disW
      }
      const disx = Math.round((_left / disW) * overWidth)
      return disx
    }
    return tableVm.scroll.disx
  } catch (e) {
    return tableVm.scroll.disx
  }
}

export function resetCollapseAnimation(vm) {
  const tableEl = getCanvasTableBoxEl(vm)
  const collapseLists = tableEl.getElementsByClassName('collapse-animation')
  Array.from(collapseLists).forEach(el => {
    if (tableEl.contains(el)) {
      tableEl.removeChild(el)
    }
  })
}

/** 动画部分【开始】************************************************/
function createCollapseAnimationEl(direction, style, type, collapsInfo, mode) {
  const el = document.createElement('div')
  el.className = `collapse-animation ${mode ? 'collapse-animation-' + mode : ''} collapse-animation-${direction} ${type === collapseType.expand ? 'collapse-animation-border' : ''} `
  el.innerHTML = `
    <div class="collapse-animation-content">
      <div class="collapse-animation-block"></div>
    </div>
  `
  el.style = style
  return el
}

function collapseAnimationRender(direction, collapsInfo, vm, type, mode) {
  const { width, x, top, isChild } = collapsInfo
  if (!width) return
  const style = `width:${width}px;left:${x}px;top:${top}px; height:calc(100% - ${isChild ? '32px' : '0px'});`
  const el = createCollapseAnimationEl(direction, style, type, collapsInfo, mode)
  getCanvasTableBoxEl(vm).appendChild(el)
}

function getCollapseAnimationInfo(groupCols = [], headerHeight, opt = {}, scrollLeft) {
  let isChild = false
  const result = groupCols.reduce((res, cur, index) => {
    cur.x -= scrollLeft
    if (index === 0) {
      res.x = cur.x
      if (cur.fixed === 'left') {
        res.x += scrollLeft
        res.isFixedGroup = true
      }
    }
    res.width += cur.width
    isChild = cur.type === 'child'
    return res
  }, {
    width: 0,
    x: 0,
    isFixedGroup: false
  })
  result.headerHeight = isChild ? headerHeight - 32 : headerHeight
  result.top = isChild ? 32 : 0
  result.isChild = isChild
  Object.assign(result, { ...opt })
  return result
}

function renderHighlightGroup(columnHighlightGroup, opt, vm, mode) {
  const { headerHeight, canvasBoxWidth, fixedLeftWidth, direction, type, rowHeight, displayRow, maxCanvasWidth } = opt
  // 核心：根据内部query-table计算disx规则手动提前计算出scroll.disx
  // const scrollLeft = getCanvasDisx(vm, columnHighlightGroup, type)
  const scrollLeft = vm.$refs.table.scroll.disx
  const highlightGroupLength = columnHighlightGroup.length
  let u = 0
  if (highlightGroupLength) {
    columnHighlightGroup.forEach(groupCols => {
      const info = getCollapseAnimationInfo(groupCols, headerHeight, { rowHeight, displayRow }, scrollLeft)
      const showWidth = info.x + info.width
      const isFixedGroup = info.isFixedGroup === true
      // 当组内容被完全隐藏的时候
      if ((showWidth < fixedLeftWidth && !isFixedGroup) || info.x > canvasBoxWidth || isNaN(info.x)) {
        u++
        if (u === highlightGroupLength) {
          resetDrawTable(vm, true)
        }
        return console.log('被隐藏的组', groupCols.map(item => item.label))
      }
      // [左]当组宽度还有一点内容在可视区域的时候，需要重新计算动画的元素的位置
      if (info.x < fixedLeftWidth && !isFixedGroup) {
        const hideWidth = fixedLeftWidth - info.x
        info.x = fixedLeftWidth
        info.width = info.width - hideWidth
      }
      // [右]当组宽度还有一点内容在可视区域的时候，需要重新计算动画的元素的位置,注意：存在canvas可视区域很多(且没有滚动条)，设置个性设置后表格变很短
      const isRightOverflow = showWidth > canvasBoxWidth && showWidth > maxCanvasWidth
      if (isRightOverflow) {
        const hideWidth = showWidth - maxCanvasWidth
        info.width = info.width - hideWidth
      }
      collapseAnimationRender(direction, info, vm, type, mode)
    })
  }
}
/** 动画部分【end】************************************************/

function getCanvasTableBoxEl(vm) {
  const { $el } = vm.$refs.table || {}
  return $el || document
}

function getColWidth(colWidthMap, col) {
  if (col.width === 'auto') {
    return parseInt(col._autoWidth) || 0
  }
  // _origWidth比width权重大的原因是因为，canvas内部可能存在把width变的不一致情况
  return parseInt(colWidthMap[col.key] || col._origWidth || col.width || 0)
}

export function removeCollapseAnimationEl(vm) {
  const $el = getCanvasTableBoxEl(vm)
  $el && Array.from($el.getElementsByClassName('collapse-animation')).forEach(el => {
    el && $el.removeChild(el)
  })
}

function getAnimationInfo(columnGroup, colWidthMap) {
  const info = columnGroup.reduce((res, cur) => {
    const groupWidth = cur.reduce((r, c) => r += getColWidth(colWidthMap, c), 0)
    res.totalWidth += groupWidth
    return res
  }, {
    totalWidth: 0,
    totalAnimationTime: 260,
    drawInterval: 0,
    drawWidth: 10,
  })
  // 10次画完求出每次的绘制宽度
  info.drawWidth = info.totalWidth / 12
  // 绘制总次数
  info.drawAllNum = info.totalWidth / info.drawWidth
  // 计算绘制的间隔
  info.drawInterval = info.totalAnimationTime / info.drawAllNum
  return info
}

function handleCollapseAnimation(type, curCollapseKes, vm, columns, mode, fixedColumns, collapseCol) {
  curCollapseKes = cloneDeep(curCollapseKes)
  // 异常兜底
  if (!vm.$el || !curCollapseKes || (curCollapseKes && curCollapseKes.length === 0)) {
    return
  }
  const { fixedLeftWidth, headerHeight, canvasBoxWidth, colWidthMap = {}, rowHeight, displayRow, maxCanvasWidth, fixedLeftCol } = vm.$refs.table || {}
  // 分组处理
  const columnGroup = []
  let consecutiveGroup = []
  const columnHighlightGroup = []
  let consecutivHighlightGroup = []

  traverseList(columns, colWidthMap, curCollapseKes, (col, _type, colX) => {
    let colWidth = getColWidth(colWidthMap, col)
    if (col.$disabeldCollapse !== true && curCollapseKes.includes(col.key)) {
      // 当父级里面有子级就收集子级，判断展开或收起是否存在子级，存在需移除。不然会存在多次收集
      if (col.children && col.children.length) {
        // 子级处理
        col.children.forEach(colChild => {
          if (colChild.$disabeldCollapse) return
          const _width = getColWidth(colWidthMap, colChild)
          // 剔除的原因是在这里做子级收集，后面traverseList抛出的子级就放弃
          curCollapseKes = curCollapseKes.filter(key => key !== colChild.key)
          consecutiveGroup.push(colChild)
          consecutivHighlightGroup.push({
            width: _width,
            x: col.fixed === 'left' ? getFixedColx(col, fixedLeftCol, fixedColumns, colWidthMap) : parseInt(colX + fixedLeftWidth),
            type: _type,
            key: col.key,
            label: colChild.label,
            fixed: col.fixed
          })
          // 存在父级false，子级也是false，展开的时候父级不会被设置显示
          if (type === collapseType.expand) {
            col.show = true
          }
          // 存在控制固定列的场景: 当有column是折叠列且又是固定列就要减去自身的width，因为前面有 + fixedLeftWidth
          if (col.fixed === 'left' && type === collapseType.collapse) {
            const [firstItem] = consecutivHighlightGroup
            firstItem.x -= _width
          }
        })
        return
      }
      consecutiveGroup.push(col)
      // 高亮连续组
      consecutivHighlightGroup.push({
        width: colWidth,
        x: col.fixed === 'left' ? getFixedColx(col, fixedLeftCol, fixedColumns, colWidthMap) : parseInt(colX + fixedLeftWidth),
        type: _type,
        key: col.key,
        label: col.label,
        fixed: col.fixed
      })
    } else {
      // 如果当前列是一个个性化配置隐藏的列，那么就不应该判断是是否是连续的组,其实这里也不会进来，因为在traverseList判读了，只是做个兜底
      if (col.$disabeldCollapse) {
        return
      }
      if (consecutiveGroup.length > 0) {
        columnGroup.push(consecutiveGroup)
        consecutiveGroup = []
      }
      // 高亮分组
      if (consecutivHighlightGroup.length) {
        columnHighlightGroup.push(consecutivHighlightGroup)
        consecutivHighlightGroup = []
      }
    }
  })
  consecutiveGroup.length && columnGroup.push(consecutiveGroup)
  consecutivHighlightGroup.length && columnHighlightGroup.push(consecutivHighlightGroup)
  const columnGroupLength = (columnGroup && columnGroup.length) || 0
  const isDisableCollapseAnimation = collapseCol.disableCollapseAnimation
  if (isDisableCollapseAnimation !== true && columnGroupLength) {
    const animationInfo = getAnimationInfo(columnGroup, colWidthMap)
    mode !== collapseMode.hover && columnGroup.forEach(group => {
      playCollapseAnimation(group, type, vm, colWidthMap, animationInfo)
    })

    // 移动列逻辑
    try {
      const { isCollapseMoveCheck } = vm.$props.options
      if(isCollapseMoveCheck !== false) {
        let lastColumn = columnHighlightGroup.at(-1)
        if (lastColumn.length) lastColumn = lastColumn.at(-1)
        if (
          type === collapseType.expand &&
          lastColumn &&
          checkColumnInOutside(lastColumn, {
            canvasBoxWidth,
            fixedLeftWidth,
            scrollLeft: vm.$refs.table.scroll.disx
          })
        ) {
          setTimeout(() => {
            qtSetScrollLeft(vm.$refs.table, lastColumn.key)
          }, 500)
        }
      }
    } catch (e) {
      console.log('e')
    }
  } else if(columnGroupLength) {
    disableCollapseAnimation(columnGroup, type, vm)
  }
}

function checkColumnInOutside(column = {}, opt) {
  if(isNaN(column.x)) return false
  const { canvasBoxWidth, fixedLeftWidth, scrollLeft } = opt
  const showWidth = parseInt(column.x + column.width) || 0
  const isFixedGroup = column.fixed === 'left'
  const _scrollLeft = scrollLeft + fixedLeftWidth
  const left = (showWidth < _scrollLeft && !isFixedGroup)
  const right = column.x > canvasBoxWidth
  return left || right || false
}

/* requistAnimation实现---start */
function playCollapseAnimation(columnGroup, type, vm, colWidthMap, animationInfo) {
  const isExpand = type === collapseType.expand
  const _columnGroup = isExpand ? columnGroup : columnGroup.reverse()
  function _executeMethods(methods, index) {
    if (index < methods.length) {
      methods[index](() => {
        _executeMethods(methods, index + 1)
      })
    } else {
      clearTimeout(updateTableTimer)
      updateTableTimer = setTimeout(() => {
        resetDrawTable(vm, true, type)
        console.log('全部执行成功')
      }, 10)
    }
  }
  const methods = _columnGroup.map((column, index) => (endCallback) => playColumnWidthAnimation(column, animationInfo, isExpand, vm, endCallback, colWidthMap, index))
  _executeMethods(methods, 0)
}

function playColumnWidthAnimation(column, animationInfo, isExpand, vm, endCallback, colWidthMap) {
  // 特殊场景暂时不做处理：width为auto，设置collapsed=true(收起状态)
  if (isExpand && column.width === 'auto' && !('_origWidth' in column)) {
    columnWidthAuto(column)
    resetDrawTable(vm, true)
    endCallback()
    return console.log('auto异常处理')
  }
  const columnWidth = getColWidth(colWidthMap, column)
  // 保存下收起前的width
  if (!isExpand || (isExpand && !column._origWidth)) {
    column._origWidth = columnWidth
  }
  let { drawWidth } = animationInfo
  //  parseInt(_origWidth || width) 默认收起的场景存在拿不到_origWidth问题
  let drawNumber = Math.round((isExpand ? parseInt(column._origWidth) : parseInt(columnWidth)) / drawWidth)
  if(drawNumber === Infinity){
    drawNumber = 1
    if(drawWidth === 0){
      drawWidth = column.width
    }
  }
  let _drawWidth = isExpand ? 0 : parseInt(columnWidth)
  let i = 1
  const _startDraw = () => {
    const lastDraw = i >= drawNumber
    isExpand ? (_drawWidth += drawWidth) : (_drawWidth -= drawWidth)
    column.width = _drawWidth
    // 兜底width为负数，和最后绘制的循环次数
    if ((!isExpand && column.width < 0) || (!isExpand && lastDraw)) {
      column.width = 0
    }
    if (column.width > column._origWidth) {
      column.width = column._origWidth
    }
    // 状态处理
    if (!isExpand && column.width === 0) {
      column.show = false
    } else {
      column.show = true
    }
    // 展开最后绘制结束
    if (isExpand && lastDraw) {
      column.width = column._origWidth
    }
    resetDrawTable(vm)
    if (lastDraw) {
      typeof endCallback === 'function' && endCallback()
    } else {
      i += 1
      window.requestAnimationFrame(_startDraw)
    }
  }
  window.requestAnimationFrame(_startDraw)
}

function columnWidthAuto(col) {
  col.show = !col.$disabeldCollapse
  col.children && col.children.forEach(child => {
    child.show = !child.$disabeldCollapse
    child.$collapse = false
  })
}


/**
 * @param {Array} cols
 * @param {Function} callback
 * @description 遍历cols 对cols执行callback
 */
const traverseList = (cols, colWidthMap, curCollapseKes, callback) => {
  let curColX = 0
  for (const col of cols) {
    if (col.$disabeldCollapse) {
      continue
    }
    callback(col, null, curColX)
    const colWidth = getColWidth(colWidthMap, col)
    curColX += colWidth
    if (!col.children) {
      continue
    } else {
      curColX -= colWidth
    }
    for (const child of col.children) {
      // 为false且不存在curColsMps里面，child.$disabeldCollapse：内部标记禁用也不展示
      if ((child.show === false && !curCollapseKes.includes(child.key))) {
        continue
      }
      if (child.$disabeldCollapse) {
        continue
      }
      callback(child, 'child', curColX, col.key)
      const childWidth = getColWidth(colWidthMap, child)
      curColX += childWidth
    }
  }
}

export function runCollapseAnimation(clickedCol, curCollapseKes = [], vm, mode) {
  const { column } = vm
  const type = clickedCol.collapsed ? collapseType.collapse : collapseType.expand
  // 获取可展示的column
  const dispalyColumns = column.filter(item => {
    return (item.show && item.fixed !== 'left') || curCollapseKes.includes(item.key)
  })
  const fixedColumns = column.filter(item => item.fixed === 'left')
  handleCollapseAnimation(type, curCollapseKes, vm, dispalyColumns, mode, fixedColumns, clickedCol)
}


export function createDrawCollapseBg(tableListVm) {
  const key = 'drawColumnCollapseBg'
  if (tableListVm) {
    const isExist = tableListVm.beforeDraws.find(fn => fn._key === key)
    if (!isExist) {
      drawColumnCollapseBg._key = key
      tableListVm.beforeDraws.push(drawColumnCollapseBg)
    }
  }
}

function drawColumnCollapseBg(ctx, paintParams, type) {
  try {
    if (!ctx || !paintParams) return
    const { col } = paintParams
    if (col.hasOwnProperty('$collapse')) {
      const { x, y, canvasTable, cellHeight = 26 } = paintParams
      const _y = type === 'painHeader' ? y : y - canvasTable.rowH / 2
      // TODO 优化调用save方法和restore方法
      ctx.save()
      ctx.globalAlpha = 0.2
      ctx.fillStyle = '#CEC0F4'
      ctx.fillRect(x - 6, _y, col.width, cellHeight)
      ctx.restore()
    }
  } catch (e){
    console.log('error', e)
  }
}


function disableCollapseAnimation(columnGroup, type, vm) {
  const isExpand = type === collapseType.expand
  const status = isExpand ? true : false
  columnGroup.forEach(columns => {
    columns.forEach(column => {
      column.show = status
    })
  })
  resetDrawTable(vm, true, type)
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/module/collapse-animation.js